// extracted by mini-css-extract-plugin
module.exports = {"legendBoxRow":"ReservationColorLegend_legendBoxRow__3Qemg","legendBox":"ReservationColorLegend_legendBox__2Zu7z"};